import { PixiSpriteResource } from "../../../../ResourceManager/PixiSpriteResource";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { CanvasSprite } from "../../../../slot/Sprite/CanvasSprite";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { Size, Scale } from "../../../.././MyHelpers";
import { WildSlideDoubleSlide } from "./WildSlideDoubleSlide";
import { SlideFactory2Params } from "./Slide";
import { ITranslatedCanvasParams, TranslatedCanvasSprite } from "../../../TranslatedCanvasSprite";

export class ExpandingWildBulkRightValue extends WildSlideDoubleSlide {

    protected expandingWildBulkSpriteTranslator : TranslatedCanvasSprite = null;
   
    

    constructor(initData: SlotGameInitData, p : SlideFactory2Params , viewSize : Size) {
		super(initData, p , viewSize);
		
		this.resid = this.resid.Add("ExpandingWildBulkRightValue");
		this.logGroup = this.logGroup.Add("ExpandingWildBulkRightValue");
		this.systemContext = this.systemContext.CreateSubContext("ExpandingWildBulkRightValue");
        this.viewSize = viewSize;

        this.wildInstruction = document.createElement("div");
        this.wildInstruction.classList.add("wild-instructionbulk");
        this.translator = p.translator;
        let params : ITranslatedCanvasParams ={
            resid : this.resid,
            path : this.path + "Slider2/WildBulkRightInfo",
            logGroup : this.logGroup,
            viewSize : this.viewSize,
            nameSpriteSlide : "WildBulkRightInfo",
            translator : this.translator,
        }
        this.expandingWildBulkSpriteTranslator = new TranslatedCanvasSprite(params);
    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        this.expandingWildBulkSpriteTranslator.PrepareResources(resourceManager);
    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
        this.expandingWildBulkSpriteTranslator.ResourcesLoaded(resourceManager);
        this.view.appendChild(this.expandingWildBulkSpriteTranslator.View());
        this.SripiteTimer = this.systemContext.TimingContext().CreateInterval("WildBulkRightInfo", this.nextAnimInterval, () => this.expandingWildBulkSpriteTranslator.Start());      
        
    }


	public override View(): HTMLElement 
	{
        return this.view;
	}
	
	public override Update() 
	{

        //this.WildSprite.Update();
        this.expandingWildBulkSpriteTranslator.Update();
	}
	
	public override Start() 
	{
        //this.WildSprite.Start(true);
        this.SripiteTimer.Start();
    }

	public override Stop() 
	{
        //this.TitleSripiteTimer.Restart();
        this.SripiteTimer.Stop();
        //this.WildSprite.StopAndReset()
    }

}

